import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { FormattedMessage } from 'react-intl';

import MProductCard from '../../molecules/_molecules.product-card';

export default function OProducts({ href, items }) {
	const cName = !items.length ? 'o-product-list-not-found' : '';
	let content = (
		<p className="not-found">
			<FormattedMessage id="NOT_FOUND.PRODUCTS" defaultMessage="" />
		</p>);

	if (items.length) {
		content = items.map(item => (
			<div
				key={get(item, 'uuid', '')}
				className="align-wrapper"
			>
				<MProductCard
					title={get(item, 'name', '')}
					img={get(item, 'featuredImage.url', '')}
					href={`${href}/${get(item, 'slug', '')}`}
					atex={get(item, 'atexes', [])}
					product={item}
				/>
			</div>
		));
	}

	return (
		<section className={`o-default-list o-product-list ${cName}`}>
			{content}
		</section>
	);
}

OProducts.propTypes = {
	href: PropTypes.string,
	items: PropTypes.array.isRequired,
};

OProducts.defaultProps = {
	href: '',
};



// WEBPACK FOOTER //
// ./src/components/organisme/product/_organisme.products.js